import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    accountsList: [],
    pageCount: 0,
    loaderForButton:false,
    dataLoader:false,
    size:0,
    total:0,
}

const accountsSlice = createSlice({
    name: 'accounts',
    initialState ,
    reducers: {
        setaccountsList(state, action) {
            state.accountsList = action.payload.pagination ? [...state.accountsList, ...action.payload.accountsList] : action.payload?.accountsList
            state.pageCount = action.payload.pageCount || 0
            state.loaderForButton = action.payload.loaderForButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.dataLoader = action.payload?.dataLoader||false
            state.size = action.payload?.size
            state.total = action.payload?.total
        },
        setAccountsLoaderForButton(state, action) {
            state.loaderForButton = action?.payload
        },
        setAccountsLoader(state,action){
            state.dataLoader = action?.payload
        },
        clearAccountsList(action, state) {
            return initialState
          }
    }
})

export const {setAccountsLoader,setAccountsLoaderForButton,setaccountsList,clearAccountsList} = accountsSlice.actions

export const accountsActions = accountsSlice.actions

export default accountsSlice